import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ShareForm from '../../components/share-form';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

const SharePostModal = ({ closeModal, categorySlug, postSlug, t }) =>
  <Modal onClose={closeModal}>
    <ShareForm title={t('share-post-modal.share-post')} path={`/${categorySlug}/${postSlug}`}/>
  </Modal>;

SharePostModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  categorySlug: PropTypes.string.isRequired,
  postSlug: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeModal,
};

export default connect(undefined, mapDispatchToProps)(withTranslate(SharePostModal));



// WEBPACK FOOTER //
// ./app/containers/share-post-modal/share-post-modal.js